module.exports = __webpack_public_path__ + "img/copytrade_sec3_2.75800271.png";